import type { Amount } from '@tectonics/prs/money';
import type { InstalmentsPlan, ReceiptGetter } from '../types';
import type { Maybe } from '@tectonics/utils/types';
import { getOrThrow } from '@tectonics/utils/getters';


type SafeInstalmentsPlanGetter<T> = (instalmentsPlan: InstalmentsPlan) => T;

export const getInstalmentsNumber: SafeInstalmentsPlanGetter<number> = (instalmentsPlan) => instalmentsPlan.instalments;

export const getAmountPartialFirst: SafeInstalmentsPlanGetter<Amount> = (instalmentsPlan) => instalmentsPlan.amount_partial_first;

export const getInstalmentsPlan: ReceiptGetter<Maybe<InstalmentsPlan>> = receipt => receipt.instalments_plan;

export const getSafeInstalmentsPlan: ReceiptGetter<InstalmentsPlan> = (receipt) => getOrThrow(
  getInstalmentsPlan(receipt),
  'getSafeInstalmentsPlan: there is not instalments plan'
);
